import CollapsibleButton from './component.jsx'
export default CollapsibleButton
